import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {ApiError, isFetchBaseQueryError} from 'shared/web';

// 409 = tenant AI spending limit reached (DMS-SS-WM-0014). 429 = rate limited: hourly tenant
// quota or upstream rate limit (DMS-SS-WM-0016). 503 = upstream unavailable (DMS-SS-WM-0017).
// 400 (invalid prompt DMS-SS-WM-0013, content policy DMS-SS-WM-0015) and 404 (DMS-SS-WM-0011)
// carry the message from the BE.
const SPENDING_LIMIT_STATUS = 409;
const RATE_LIMITED_STATUS = 429;
const UNAVAILABLE_STATUS = 503;

export const notifyBadgeGenerationError = (error: ApiError) => {
  const status = isFetchBaseQueryError(error) ? error.status : null;

  match(status)
    .with(SPENDING_LIMIT_STATUS, () =>
      showNotification.error(
        i18n.t('entity.watermark.composition.ai.notifications.spendingLimitReached')
      )
    )
    .with(RATE_LIMITED_STATUS, () =>
      showNotification.error(i18n.t('entity.watermark.composition.ai.notifications.rateLimited'))
    )
    .with(UNAVAILABLE_STATUS, () =>
      showNotification.error(i18n.t('entity.watermark.composition.ai.notifications.unavailable'))
    )
    .otherwise(() => handleApiError(error));
};
